import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { IconCheck, IconContentCopy } from '@travel-frontend/icons';
import { useCallback, useRef, useState } from 'react';
import { Button } from '../../primitives/Button/index.js';
export const CopyToClipboardButton = ({
  value,
  children,
  onClick,
  category = 'secondary',
  variant = 'info',
  resetTimeout = 5000,
  ...restProps
}) => {
  const [copySuccessful, setCopySuccessful] = useState(false);
  const buttonWasClicked = useRef(false);
  const icon = copySuccessful ? _jsx(IconCheck, {
    stroke: "currentColor",
    "stroke-width": "2"
  }) : _jsx(IconContentCopy, {});
  const handleClick = useCallback(event => {
    if (!buttonWasClicked.current) {
      navigator.clipboard.writeText(value).then(() => {
        setCopySuccessful(true);
        if (!buttonWasClicked.current && !copySuccessful) return;
        setTimeout(() => {
          buttonWasClicked.current = false;
          setCopySuccessful(false);
        }, resetTimeout);
      }).catch(() => {
        buttonWasClicked.current = false;
      });
    }
    buttonWasClicked.current = true;
    onClick?.(event);
  }, [onClick, value, copySuccessful, resetTimeout]);
  return _jsx(Button, {
    ...restProps,
    variant: variant,
    category: category,
    icon: icon,
    iconPosition: "left",
    onClick: handleClick,
    children: children
  });
};